import { useEffect } from "react";
import { useNav } from "../context/NavContext";

const SECTION_IDS = ["home", "about", "projects", "skills", "contact"];
const NAV_HEIGHT = 64;

export default function useActiveSection() {
  const { activeSection, setActiveSection, manualClick } = useNav();

  useEffect(() => {
    function checkSection() {
      if (manualClick.current) return;

      let current = activeSection;
      const scrollPos = window.scrollY + NAV_HEIGHT;

      SECTION_IDS.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;

        if (scrollPos >= el.offsetTop - 5) {
          current = id;
        }
      });

      setActiveSection(current);
    }

    window.addEventListener("scroll", checkSection, { passive: true });

    return () => window.removeEventListener("scroll", checkSection);
  }, []);

  return activeSection;
}
